import { SlideUpModal } from "src/components/SlideUpModal";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";
import { useWebClientApi } from "src/api";

type DeleteIncomeModalProps = {
  isOpen: boolean;
  income_id: string;
  closeHandler: () => void;
  deleteHandler: () => void;
};

export default ({
  isOpen,
  income_id,
  closeHandler,
  deleteHandler,
}: DeleteIncomeModalProps) => {
  const api = useWebClientApi();
  const [submitDelete, loading] = useDlaFormSubmit(
    async () => {
      await api.deleteIncome(income_id);
    },
    {
      onSuccess: () => deleteHandler(),
    },
  );

  if (!isOpen) return null;

  return (
    <SlideUpModal
      title="Remove this income"
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Remove"
      isLoading={loading}
      actionButtonClickHandler={() => {
        void submitDelete({});
      }}
    >
      This action cannot be undone.
    </SlideUpModal>
  );
};
